import { get, post, put, remove as httpRemove } from '../Services/http';
import { catchError } from './Error.action';

export const ADDRESS_RECEIVE = 'ADDRESS_RECEIVE';
export const ADDRESS_ERROR = 'ADDRESS_ERROR';
export const ADDRESS_CHANGE_MODE = 'ADDRESS_CHANGE_MODE';
export const CITY_RECEIVE = 'CITY_RECEIVE';

const rootRoute = '/api/mypageaddress';

export const changeMode = mode => ({
    type: ADDRESS_CHANGE_MODE,
    payload: {
        mode,
    }
})
 
export const query = (mode = 'list') => (dispatch) => {
    return get(rootRoute)
        .then(response => response.json())
        .then(result => {
            dispatch(receive(result, mode));
        })
        .catch(ex => dispatch(catchError(ex, error => setError(error))))
        ;
}

export const checkZipCode = (zip, langCode) => (dispatch, getState) => {
    zip = zip.trim();
    // ENCODE
    zip = encodeURI(zip);
    return get(rootRoute + '/getCityFromZip/' + langCode + '/' + zip)
        .then(response => response.json())
        .then(result => dispatch(setCity(result)))
        .catch(ex => dispatch(catchError(ex, error => setError(error))))
        ;
}

export const remove = (addressSystemId) => (dispatch) => 
    httpRemove(rootRoute, addressSystemId)
        .then(() => dispatch(query()))
        .catch(ex => dispatch(catchError(ex, error => setError(error))))
        ;

export const add = (address) => (dispatch) => 
    
    post(rootRoute, address)
        .then(() => dispatch(query()))
        .catch(ex => dispatch(catchError(ex, error => setError(error))))
        ;


export const setCity = (cityObj) => (dispatch, getState) => {

    if ((cityObj && cityObj.city && cityObj.city.length > 0) || cityObj.errorCode.length > 1) {
        dispatch({
            type: CITY_RECEIVE,
            payload: {
                cityObj
            }
        });
        return true;
    }
    // Reset error
    else if (cityObj.errorCode === "") {

        const cityEl = document.getElementById('city');
        let cityName = '';
        if (cityEl) {
            cityName = cityEl.value;
        }

        let cityObjTemp = {
            city: cityName,
            errorCode: ""
        };
       
        dispatch({
            type: CITY_RECEIVE,
            payload: {
                cityObj: cityObjTemp
            }
        });
    }

    return true;
}


// Used from within checkout
export const addDeliveryAddress = (address) => (dispatch) => {
    address.deliveryType = 'Delivery';
    return post(rootRoute + '/addDeliveryAddress', address)
        .then(() => dispatch(query()))
        .catch(ex => dispatch(catchError(ex, error => setError(error))));
}

export const edit = (address) => (dispatch) =>
    put(rootRoute, address)
        .then(() => dispatch(query()))
        .catch(ex => dispatch(catchError(ex, error => setError(error))))
        ;

const receive = (list, mode) => ({
    type: ADDRESS_RECEIVE,
    payload: {
        list,
        mode,
    },
})

export const setError = (error) => (dispatch) => {
//export const setError = error => ({

    dispatch({
        type: ADDRESS_ERROR,
        payload: {
            error,
        }
    });
}


